<template>

<com-content :loading="is.loading" :text="text" :empty="!vacancies.length && !people.length">

    <app-wrapper v-if="people.length" class="people">

        <div class="people-item" v-for="(person, index) in people" :key="index">

            <div class="people-item-avatar" :style="{backgroundImage: $util.thumbnail(person.image)}"></div>

            <div class="people-item-text">

                <div class="people-item-text-name">{{ person.name }}</div>
                <div class="people-item-text-role">{{ person.role }}</div>
                <div class="people-item-text-description">{{ person.text }}</div>

            </div>

        </div>

    </app-wrapper>

    <app-wrapper v-if="vacancies.length" class="vacancies">

        <div class="vacancies-title">{{ page.people_vacancies }}</div>

        <div class="vacancies-item" v-for="(vacancy, index) in vacancies" :key="index">

            <div class="vacancies-item-text">

                <div class="vacancies-item-text-name">{{ vacancy.name }}</div>

                <div class="vacancies-item-text-detail" v-if="vacancy.type || vacancy.rate">
					<template v-if="vacancy.type">{{ $constants.vacancy[vacancy.type] }}</template>
					<template v-if="vacancy.rate"><template v-if="vacancy.type">, </template>{{ vacancy.rate }}</template>
				</div>

                <div class="vacancies-item-text-description"><com-br tag="p" :text="vacancy.text" /></div>

            </div>

            <div class="vacancies-item-actions">

                <app-button theme="blue" :expand="true" :text="page.people_apply" v-on:click="onApplyClick(vacancy.id)" />

            </div>

        </div>

    </app-wrapper>

</com-content>

</template>

<script>

import comContent from './common/Content'
import comBR from 'vue-nl2br'

export default {

    components: {
		'com-br': comBR,
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
                loading: false
            },
            people: [],
            vacancies: []
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.people_empty
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/people', {
                slug: this.page.business.slug
            }).then(function(json) {

                this.people = json.people
                this.vacancies = json.vacancies

                this.is.loading = false

            }.bind(this))

        },

        onApplyClick: function(id) {

            this.$pubsub.$emit('modal.open', {
                name: 'vacancy/apply',
                vacancy: id
            })

        }

    }

}

</script>

<style scoped>

.people {
    margin-bottom: 40px;
}

.is-mobile .people {
    margin-bottom: 20px;
}

.people:last-child {
    margin-bottom: 0px;
}

.people-item {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;;
}

.is-mobile .people-item {
    padding: 10px;
}

.is-desktop .people-item:hover {
    border-color: var(--color-grey-highlight);
}

.people-item:last-child {
    margin-bottom: 0px;
}

.people-item-avatar {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    border-radius: 4px;
    background-size: cover;
    background-position: 50% 50%;
    flex-shrink: 0;
}
.is-mobile .people-item-avatar {
    width: 64px;
    height: 64px;
    margin-right: 10px;
}

.people-item-text {
    flex-grow: 1;
}

.people-item-text-name {
    font-size: 18px;
    color: var(--color-grey-dark);
    line-height: 22px;
    font-family: "grueber",serif;
}

.people-item-text-role {
    font-size: 14px;
    color: var(--color-grey-dark);
    font-weight: 300;
    margin-bottom: 18px;
}

.people-item-text-description {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-grey-dark);
    font-weight: 300;
}

.vacancies-title {
    font-size: 20px;
    color: var(--color-grey-dark);
    margin-bottom: 20px;
    text-align: center;
    font-family: "grueber",serif;
}

.is-mobile .vacancies-title {
    font-size: 16px;
}

.vacancies-item {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.is-mobile .vacancies-item {
    flex-direction: column;
	align-items: flex-start;
}

.is-desktop .vacancies-item:hover {
    border-color: var(--color-grey-highlight);
}

.vacancies-item-text {
    flex-grow: 1;
}

.vacancies-item-text-name {
    font-size: 18px;
    color: var(--color-blue-dark);
    line-height: 22px;
    font-family: "grueber",serif;
}

.vacancies-item-text-detail {
    font-size: 14px;
    color: var(--color-grey-dark);
	font-weight: 400;
	margin-bottom: 20px;
}

.vacancies-item-text-description {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-grey-dark);
    font-weight: 300;
}

.vacancies-item-actions {
    width: 120px;
    padding-top: 18px;
    margin-left: 20px;
    flex-shrink: 0;
}

.is-mobile .vacancies-item-actions {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-left: 0px;
}

.is-mobile .vacancies-item-actions >>> .button {
	margin-bottom: 0px;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
}

</style>